import { Editor } from '@tiptap/react';
import React from 'react';
import {
  BlockQuoteIcon,
  BoldIcon,
  BulletListIcon,
  H1Icon,
  H2Icon,
  H3Icon,
  HorizontalRuleIcon,
  ItalicIcon,
  OrderedListIcon,
  RedoIcon,
  UndoIcon,
} from '../../icons/icons';
import { IconButton } from './IconButton';

interface EditorToolbarProps {
  editor: Editor | null;
}

const EditorToolbar: React.FC<EditorToolbarProps> = ({ editor }) => {
  if (!editor) {
    return null;
  }

  const BUTTON_DATA = [
    {
      action: 'bold',
      onClick: () => editor.chain().focus().toggleBold().run(),
      icon: <BoldIcon/>,
    },
    {
      action: 'italic',
      onClick: () => editor.chain().focus().toggleItalic().run(),
      icon: <ItalicIcon/>,
    },
    {
      action: 'h1',
      onClick: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),
      icon: <H1Icon/>,
    },
    {
      action: 'h2',
      onClick: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),
      icon: <H2Icon/>,
    },
    {
      action: 'h3',
      onClick: () => editor.chain().focus().toggleHeading({ level: 3 }).run(),
      icon: <H3Icon/>,
    },
    {
      action: 'bullet-list',
      onClick: () => editor.chain().focus().toggleBulletList().run(),
      icon: <BulletListIcon/>,
    },
    {
      action: 'ordered-list',
      onClick: () => editor.chain().focus().toggleOrderedList().run(),
      icon: <OrderedListIcon/>,
    },
    {
      action: 'blockquote',
      onClick: () => editor.chain().focus().toggleBlockquote().run(),
      icon: <BlockQuoteIcon/>,
    },
    {
      action: 'horizontal-rule',
      onClick: () => editor.chain().focus().setHorizontalRule().run(),
      icon: <HorizontalRuleIcon/>,
    },
    {
      action: 'undo',
      onClick: () => editor.chain().focus().undo().run(),
      icon: <UndoIcon/>,
    },
    {
      action: 'redo',
      onClick: () => editor.chain().focus().redo().run(),
      icon: <RedoIcon/>,
    },
  ];

  return (
    <div className='flex max-w-full flex-row gap-1 overflow-x-auto rounded-lg bg-gray-200 p-1 mb-3'>
      { BUTTON_DATA.map((button) => (
        <IconButton
            key={button.action}
            onClick={button.onClick}
            icon={button.icon}
        />
      )) }
    </div>
  );
};

export default EditorToolbar;
